import React from 'react';
import { IconProps } from './types';

export const CustomWhatsappIcon: React.FC<IconProps> = props => {
  const {
    height = 17,
    width = 16,
    fillColor = 'white',
    fillColor1 = 'var(--green-light-11)'
  } = props;
  return (
    <svg
      height={height}
      width={width}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1590_1137)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6687 2.33698C12.1648 0.831177 10.1647 0.0014964 8.0336 0.000732422C3.64227 0.000732422 0.068376 3.57424 0.066848 7.96673C0.066084 9.37091 0.433176 10.7415 1.13031 11.9494L0 16.0779L4.22327 14.9701C5.3868 15.605 6.69702 15.9392 8.03018 15.9396H8.0336C12.4242 15.9396 15.9985 12.3657 16 7.97322C16.0008 5.84442 15.173 3.84316 13.6687 2.33736V2.33698ZM8.0336 14.5942H8.03093C6.84293 14.5939 5.67751 14.2745 4.66067 13.6714L4.41885 13.5278L1.91262 14.1851L2.58148 11.7415L2.4241 11.491C1.76135 10.4367 1.41107 9.21811 1.41183 7.96713C1.41336 4.31645 4.38371 1.3461 8.03631 1.3461C9.80489 1.34686 11.4673 2.03635 12.7176 3.28813C13.9678 4.53953 14.6558 6.20349 14.655 7.97247C14.6535 11.6235 11.6832 14.5939 8.0336 14.5939V14.5942ZM11.6656 9.63526C11.4665 9.53558 10.4879 9.05424 10.3053 8.9878C10.1227 8.92131 9.99018 8.88811 9.8576 9.08749C9.72507 9.28691 9.34347 9.73535 9.22733 9.86789C9.1112 10.0008 8.99507 10.0173 8.79604 9.91753C8.59707 9.81784 7.95569 9.60775 7.19516 8.92971C6.60347 8.4018 6.20387 7.75015 6.08778 7.55073C5.97164 7.35135 6.07556 7.24362 6.17484 7.14469C6.26422 7.05531 6.37387 6.91207 6.47356 6.79593C6.57329 6.6798 6.60613 6.59655 6.67258 6.46398C6.73907 6.33104 6.70582 6.21495 6.65618 6.11522C6.60649 6.01553 6.20849 5.03571 6.04231 4.63731C5.88071 4.24922 5.71649 4.30193 5.59462 4.29544C5.47849 4.28971 5.34596 4.28856 5.21302 4.28856C5.08009 4.28856 4.86462 4.33822 4.68204 4.53762C4.49947 4.737 3.98529 5.21869 3.98529 6.19811C3.98529 7.17753 4.69849 8.12451 4.79818 8.25744C4.89787 8.39038 6.20196 10.4008 8.19862 11.2633C8.67347 11.4684 9.04436 11.591 9.33351 11.6827C9.81027 11.8344 10.2442 11.813 10.5872 11.7618C10.9696 11.7045 11.7649 11.2801 11.9307 10.8152C12.0964 10.3503 12.0964 9.95153 12.0468 9.86864C11.9972 9.78575 11.8642 9.73571 11.6652 9.63602L11.6656 9.63526Z"
          fill={fillColor1}
        />
      </g>
      <defs>
        <clipPath id="clip0_1590_1137">
          <rect width="16" height="16.0889" fill={fillColor} />
        </clipPath>
      </defs>
    </svg>
  );
};
